<template>
  <div class="SubMenuGrouping" :class="{ verbose: content.entries.some((entry) => entry.description) }">
    <MenuGroupHeading v-if="content.title" class="menuGroupHeading" :title="content.title" />
    <MenuGroupItem v-for="entry in content.entries"
      :key="entry.title"
      class="menuItem"
      v-bind="entry"
    />
  </div>
</template>

<script>
import MenuGroupHeading from '../shared/MenuGroupHeading.vue'
import MenuGroupItem from '../shared/MenuGroupItem.vue'

export default {
  components: {
    MenuGroupHeading,
    MenuGroupItem,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>

.SubMenuGrouping {
  margin-top: var(--spacing-11);
}

.SubMenuGrouping + .SubMenuGrouping {
  margin-top: var(--spacing-14);
}

.SubMenuGrouping.verbose {
  margin-top: var(--spacing-14);
  padding-bottom: var(--spacing-14);
}

.SubMenuGrouping.verbose:not(:last-child) {
  margin-bottom: var(--spacing-14);
  border-bottom: thin solid var(--menu-hairline-color);
}

.menuItem {
  --title-font-size: var(--font-size-3);
  max-width: 16rem;
}

.menuGroupHeading + .menuItem {
  margin-top: var(--spacing-8);
}

.menuItem + .menuItem {
  margin-top: var(--spacing-11);
}
</style>
